var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 56,
    viewBox: "0 0 136 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.826 21.7188C130.199 21.7188 135.384 26.9068 135.384 33.2764C135.384 39.6524 130.199 44.8404 123.826 44.8404C117.452 44.8404 112.267 39.6524 112.267 33.2764C112.273 26.9005 117.452 21.7188 123.826 21.7188ZM123.826 42.9636C129.163 42.9636 133.508 38.6161 133.508 33.2764C133.508 27.9368 129.163 23.5892 123.826 23.5892C118.488 23.5892 114.143 27.9368 114.143 33.2764C114.143 38.6161 118.488 42.9636 123.826 42.9636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7083 21.7188C91.0815 21.7188 96.2673 26.9068 96.2673 33.2764C96.2673 39.6524 91.0815 44.8404 84.7083 44.8404C78.3351 44.8404 73.1494 39.6524 73.1494 33.2764C73.1494 26.9005 78.3351 21.7188 84.7083 21.7188ZM84.7083 42.9636C90.0457 42.9636 94.3913 38.6161 94.3913 33.2764C94.3913 27.9368 90.0457 23.5892 84.7083 23.5892C79.371 23.5892 75.0254 27.9368 75.0254 33.2764C75.0254 38.6161 79.371 42.9636 84.7083 42.9636Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2987 21.7188C52.6719 21.7188 57.8576 26.9068 57.8576 33.2764C57.8576 39.6524 52.6719 44.8404 46.2987 44.8404C39.9255 44.8404 34.7461 39.6524 34.7461 33.2764C34.7398 26.9005 39.9255 21.7188 46.2987 21.7188ZM46.2987 42.9636C51.636 42.9636 55.9817 38.6161 55.9817 33.2764C55.9817 27.9368 51.636 23.5892 46.2987 23.5892C40.9614 23.5892 36.6157 27.9368 36.6157 33.2764C36.6157 38.6161 40.9614 42.9636 46.2987 42.9636Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0537 11.9557H114.465L124.489 21.9905L123.162 23.3175L113.688 13.8325H14.0537V11.9557Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9951 6.79935H13.1191V18.9889H14.9951V6.79935Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80664 5.15637H68.5447L85.3715 21.9905L84.0451 23.3175L67.7678 7.03315H7.80664V5.15637Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74802 0H6.87207V12.1896H8.74802V0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6354 43.2417L46.9619 44.5624L40.9361 50.5908H0.93457V48.714H40.1591L45.6354 43.2417Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87596 43.5576H0V55.7472H1.87596V43.5576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR1);
export default __webpack_public_path__ + "static/media/r1.67f1aa8b41e7f6dcfb1ba3378a799130.svg";
export { ForwardRef as ReactComponent };